export const N69_01 = {
    "columns": 12,
    "rows": 2,
    "visual": {
        "id": 1,
        "type": "advancedTable",
        "colorTheme": 'colorTheme1',
        "title": "Product Sales Performance",
        "binding": {
            "data": {
                "columns": [
                    {
                        "name": 'Product Name',
                        "columnName": 'ItemName',
                        "width": '200px',
                        "align": "left",
                        "sortable": true,
                        "sum": false,
                    },
                    {
                        "name": 'Target',
                        "columnName": 'TargetSales',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Actual Sales',
                        "columnName": 'ActualSales',
                        "width": '140px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": 'Performance %',
                        "columnName": 'Performance',
                        "width": '220px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": '% Share',
                        "columnName": 'ActualShare',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'LY Sales',
                        "columnName": 'LYSales',
                        "width": '125px',
                        "align": "right",
                        "sortable": true,
                        "sum": true,
                    },
                    {
                        "name": '% Share',
                        "columnName": 'LYShare',
                        "width": '120px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    },
                    {
                        "name": 'Growth %',
                        "columnName": 'Growth',
                        "width": '118px',
                        "align": "right",
                        "sortable": true,
                        "sum": false,
                        "percent": true
                    }
                ],
                "title": "ItemName",
                "endpoint": "N69.1",
                "parameters": [
                    { "key": "FromMonth", "value": "2024" },
                    { "key": "FromYear", "value": "1" },
                    { "key": "ToMonth", "value": "2024" },
                    { "key": "ToYear", "value": "1" },
                    { "key": "RegionCode", "value": "" },
                    { "key": "ConfigTypeCode", "value": "" }
                ]
            },
            "context": {
                "point": {
                    "onClick": {
                        "selectedValueColumn": "ItemCode",
                        "selectedTitle": "Customer Group",
                        "visual": [
                            {
                                "columns": 12,
                                "rows": 3,
                                "visual": {
                                    "id": 1,
                                    "type": "bar",
                                    "title": "Customer Group",
                                    "colorTheme": 'colorTheme2',
                                    "orientation": "horizontal",
                                    "xAxis": "Sales",
                                    "yAxis": "",
                                    "binding": {
                                        "data": {
                                            "series": [
                                                {
                                                    "name": 'Sales',
                                                    "value": 'ActualSales',
                                                    "type": 'column'
                                                }
                                            ],
                                            "title": "CustomerGroup",
                                            "endpoint": "N70.3",
                                            "parameters": [
                                                { "key": "FromMonth", "value": "" },
                                                { "key": "FromYear", "value": "" },
                                                { "key": "ToMonth", "value": "" },
                                                { "key": "ToYear", "value": "" },
                                                { "key": "ItemCode", "value": "" },
                                                { "key": "RegionCode", "value": "" },
                                                { "key": "ConfigTypeCode", "value": "" }
                                            ]
                                        },
                                        "context": {
                                            "point": {
                                                "onClick": {
                                                    "selectedValueColumn": "ItemCodeCustomerGroup",
                                                    "selectedTitle": "Channel",
                                                    "visual": [
                                                        {
                                                            "columns": 12,
                                                            "rows": 3,
                                                            "visual": {
                                                                "id": 1,
                                                                "type": "advancedTable",
                                                                "colorTheme": 'colorTheme1',
                                                                "title": "Channel Sales",
                                                                "binding": {
                                                                    "data": {
                                                                        "columns": [
                                                                            {
                                                                                "name": 'Channel Code',
                                                                                "columnName": 'DistributorCode',
                                                                                "width": '150px',
                                                                                "align": "left",
                                                                                "sortable": true,
                                                                                "sum": false,
                                                                            },
                                                                            {
                                                                                "name": 'Channel Name',
                                                                                "columnName": 'DistributorName',
                                                                                "width": '300px',
                                                                                "align": "left",
                                                                                "sortable": true,
                                                                                "sum": false,
                                                                            },
                                                                            {
                                                                                "name": 'Actual Sales',
                                                                                "columnName": 'ActualSales',
                                                                                "width": '160px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": true,
                                                                            },
                                                                            {
                                                                                "name": 'LY Sales',
                                                                                "columnName": 'LYSales',
                                                                                "width": '160px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "sum": true,
                                                                            },
                                                                            {
                                                                                "name": 'Growth %',
                                                                                "columnName": 'Growth',
                                                                                "width": '160px',
                                                                                "align": "right",
                                                                                "sortable": true,
                                                                                "percent": true
                                                                            }
                                                                        ],
                                                                        "title": "CustomerName",
                                                                        "endpoint": "N70.5",
                                                                        "parameters": [
                                                                            { "key": "FromMonth", "value": "" },
                                                                            { "key": "FromYear", "value": "" },
                                                                            { "key": "ToMonth", "value": "" },
                                                                            { "key": "ToYear", "value": "" },
                                                                            { "key": "ItemCodeCustomerGroup", "value": "" },
                                                                            { "key": "RegionCode", "value": "" },
                                                                            { "key": "ConfigTypeCode", "value": "" }
                                                                        ]
                                                                    },
                                                                    "context": {
                                                                        "point": {
                                                                            "onClick": {
                                                                                "selectedValueColumn": "ItemCodeCustomerGroup",
                                                                                "selectedTitle": "Customer Name",
                                                                                "visual": [
                                                                                    {
                                                                                        "columns": 12,
                                                                                        "rows": 3,
                                                                                        "visual": {
                                                                                            "id": 1,
                                                                                            "type": "advancedTable",
                                                                                            "colorTheme": 'colorTheme1',
                                                                                            "title": "Customer Sales",
                                                                                            "binding": {
                                                                                                "data": {
                                                                                                    "columns": [
                                                                                                        {
                                                                                                            "name": 'Customer Name',
                                                                                                            "columnName": 'CustomerName',
                                                                                                            "width": '500px',
                                                                                                            "align": "left",
                                                                                                            "sortable": true,
                                                                                                            "sum": false,
                                                                                                        },
                                                                                                        {
                                                                                                            "name": 'Actual Sales',
                                                                                                            "columnName": 'ActualSales',
                                                                                                            "width": '160px',
                                                                                                            "align": "right",
                                                                                                            "sortable": true,
                                                                                                            "sum": true,
                                                                                                        },
                                                                                                        {
                                                                                                            "name": 'LY Sales',
                                                                                                            "columnName": 'LYSales',
                                                                                                            "width": '160px',
                                                                                                            "align": "right",
                                                                                                            "sortable": true,
                                                                                                            "sum": true,
                                                                                                        },
                                                                                                        {
                                                                                                            "name": 'Growth %',
                                                                                                            "columnName": 'Growth',
                                                                                                            "width": '160px',
                                                                                                            "align": "right",
                                                                                                            "sortable": true,
                                                                                                            "percent": true
                                                                                                        }
                                                                                                    ],
                                                                                                    "title": "CustomerName",
                                                                                                    "endpoint": "N70.4",
                                                                                                    "parameters": [
                                                                                                        { "key": "FromMonth", "value": "" },
                                                                                                        { "key": "FromYear", "value": "" },
                                                                                                        { "key": "ToMonth", "value": "" },
                                                                                                        { "key": "ToYear", "value": "" },
                                                                                                        { "key": "ItemCodeCustomerGroup", "value": "" },
                                                                                                        { "key": "RegionCode", "value": "" },
                                                                                                        { "key": "ConfigTypeCode", "value": "" }
                                                                                                    ]
                                                                                                },
                                                                                                "context": {
                                                                                                    "point": {
                                                                                                        "onClick": {

                                                                                                        }
                                                                                                    }
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                    }
                                                                                ]
                                                                            }
                                                                        }
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        ]
                    }
                }
            }
        }
    }
}